import React from 'react';
import { Accordion } from 'react-bootstrap';
import Info from '../components/Info/Info';
import { DepositLogos } from 'lb-components/src/stories/assets/icons/payment';
import { UseNavigation } from 'lb-store/src/hooks';

const entries = [
  {
    key: 'EPay',
    content: (
      <>
        <p>
          ბალანსიდან საიტზე რეგისტრირებული VISA/MASTERCARD ბარათზე თანხის
          გასატანად, დააჭირეთ ღილაკს „გატანა“, რის შემდეგაც გამოსული ფანჯრის
          პირველ ველში აირჩიეთ სასურველი ბარათი და გრაფაში „თანხა“ ჩაწერეთ
          თქვენთვის სასურველი თანხის ოდენობა. დააჭირეთ ღილაკს „თანხის და თანხა
          გადაირიცხება თქვენს ბარათზე.
        </p>
        <p>
          გთხოვთ გაითვალისწინოთ, რომ ვებ-გვერდზე ბარათის დარეგისტრირების გარეშე
          თანხის გატანის ოპერაცია თქვენს ბარათზე ვერ შესრულდება!
        </p>
      </>
    ),
    limit: { min: '1', max: '2 000',maxAmount: '200 000' },
  },
  {
    key: 'TbcPay',
    content: <p>თიბისი ფეი</p>,
    limit: { min: '1', max: '3 000',maxAmount: '200 000' },
  },
  { key: 'Oppa', content: <p>ოპპა</p>, limit: { min: '1', max: '1 000',maxAmount: '200 000' } },
  { key: 'Lb', content: null, limit: '' },
];

export default ({ User, actionType, platform, t, ...props }) => {
  const { navigate } = UseNavigation();
  return (
    <Accordion>
      {entries.map((item) => (
        <Info
          limit={item.limit}
          actionType={actionType}
          key={item.key}
          platform={platform}
          eventKey={item.key}
          t={t}
          header={
            <div
              style={{
                display: 'flex',
                flexDirection: platform === 'web' ? 'row' : 'column',
              }}
            >
              <span
                style={{
                  color: 'inherit',
                  fontSize: platform === 'mob' ? '1.15rem' : 'inherit',
                }}
              >
                PIN:
              </span>
              <span style={platform === 'web' ? { marginLeft: '1rem' } : {}}>
                {User.data?.pin}
              </span>
            </div>
          }
          content={item.content}
          logo={DepositLogos[item.key]}
          style={{ marginBottom: '1.2rem' }}
          navigate={navigate}
        />
      ))}
    </Accordion>
  );
};
